<template>
  <b-overlay variant="light" opacity=".3" blur="2px" :show="is_loading">
    <b-form @submit="onSubmit" class="form-contato-concedente">
      <h4>Identificação</h4>
      <div class="row no-gutters border rounded-lg p-3 mb-3">
        <b-form-group label="Nome do contato ou setor:" class="col-12 mb-3">
          <b-form-input
            v-model="concedente_contato.nome"
            placeholder="Nome"
            :state="validateState('nome')"
          />
          <b-form-invalid-feedback>
            Nome é um campo obrigatório.
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group label="Finalidade / função:" class="col-12">
          <b-form-input
            v-model="concedente_contato.funcao"
            placeholder="Função"
          ></b-form-input>
        </b-form-group>
      </div>

      <h4>Telefone e Mídias Sociais</h4>
      <Contatos
        v-model="concedente_contato.contatos"
        ref="contatos"
        class="border p-3 rounded-lg mb-3"
      />

      <h4>Endereço</h4>
      <block-checkbox
        v-model="concedente_contato.sem_endereco"
        title="Sem endereço"
        description="O concedente não possui endereço físico disponível"
        class="mb-3"
      />

      <Endereco
        v-if="!concedente_contato.sem_endereco"
        v-model="concedente_contato.endereco"
        ref="endereco"
        :cep_required="false"
        :logradouro_required="false"
        :numero_required="false"
        :bairro_required="false"
        :cidade_id_required="false"
        class="border p-3 rounded-lg mb-3"
      />
      <div
        v-else
        class="d-flex flex-column align-items-center w-100 py-5 border"
      >
        <font-awesome-icon
          icon="thumbtack-slash"
          size="xl"
          class="mt-3 mb-2 text-exitos"
        />
        <h4 class="text-exitos mb-0">Sem endereço</h4>
        <p class="text-center text-muted">Nenhum endereço informado</p>
        <b-button
          variant="exitos"
          size="sm"
          pill
          @click="concedente_contato.sem_endereco = false"
        >
          Adicionar endereço
        </b-button>
      </div>
    </b-form>
  </b-overlay>
</template>

<script>
import Endereco from "@/components/Form/Endereco.vue";
import Contatos from "@/components/Form/Contatos.vue";
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import { mapActions, mapState } from "vuex";
import BlockCheckbox from "@/components/Inputs/BlockCheckbox.vue";

export default {
  components: { Endereco, Contatos, BlockCheckbox },
  mixins: [validationMixin],
  props: {
    concedente_contato_id: {
      type: Number,
      default: null,
    },
  },
  data: () => ({}),
  validations: {
    concedente_contato: {
      nome: {
        required,
        minLength: minLength(3),
      },
    },
  },
  computed: {
    ...mapState("concedentes", ["concedente"]),
    ...mapState("concedentes_contatos", ["concedente_contato", "is_loading"]),
  },
  methods: {
    ...mapActions("concedentes_contatos", [
      "ActionNewConcedenteContato",
      "ActionSave",
      "ActionShow",
    ]),
    validateState(name) {
      const { $dirty, $error } = this.$v.concedente_contato[name];
      return $dirty ? !$error : null;
    },
    async onSubmit(event) {
      event.preventDefault();

      if (!this.isValid()) {
        this.$notifications.addNotification({
          message: "Os dados do formulário são inválidos",
          type: "danger",
        });
      } else {
        try {
          this.concedente_contato.concedente_id = this.concedente.id;
          await this.ActionSave(this.concedente_contato);
          this.$emit("saved", this.concedente.id);

          this.$notifications.addNotification({
            message: "Registro salvo com sucesso",
            type: "success",
          });
        } catch (error) {
          let error_message = "Erro ao salvar";
          this.$notifications.addNotification({
            message: error_message,
            icon: "exclamation-triangle",
            type: "danger",
          });
        }
      }
    },
    isValid() {
      this.$v.concedente_contato.$touch();

      let validations = {
        endereco: true,
        contatos: true,
      };
      validations.endereco = this.concedente_contato.sem_endereco
        ? true
        : this.$refs.endereco.isValid();
      validations.contatos = this.$refs.contatos.isValid();

      return (
        !this.$v.concedente_contato.$anyError &&
        Object.values(validations).every(Boolean)
      );
    },
  },
  async created() {
    this.ActionNewConcedenteContato();
    if (this.concedente_contato_id) {
      await this.ActionShow(this.concedente_contato_id);
    }
  },
};
</script>

<style lang="scss">
.form-contato-concedente {
  .element-contatos {
    display: flex;
    flex-direction: column;

    .form-group + .form-group {
      border-top: 1px solid rgba(var(--default-rgb), 1);
    }

    .input-group {
      margin-bottom: 0.25rem;
    }
  }
}

.input-sem-endereco {
  .custom-control-label {
    line-height: 1.4rem;
  }
}
</style>
